module.exports = __webpack_public_path__ + "static/media/icon-subir_doc.d36328de.svg";